import type { A2uiPayload } from '../../components/GritClaw/a2ui/types';
import type { WakeResult } from '../../services/Api/gritClawClient';
import type { ChatMessage } from './GritClawProvider';

const newId = (): string =>
  typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(16).slice(2)}`;

const assistantRow = (text: string, uiBlocks: A2uiPayload[]): ChatMessage => ({
  id: newId(),
  role: 'assistant',
  text,
  uiBlocks,
  activeTools: [],
  streaming: false,
});

/** Pending proactive items -> assistant rows, each KEEPING its own ui_blocks. */
export const pendingToMessages = (
  pending: WakeResult['pending']
): ChatMessage[] => pending.map((p) => assistantRow(p.text, p.ui_blocks ?? []));

/** Unread badge = pending items not yet seen this open; never negative. */
export const badgeCount = (
  pending: WakeResult['pending'],
  seen: number
): number => Math.max(0, pending.length - seen);

/** Pending FIRST, then greeting, prepended above existing messages (mirrors the
 *  Wave-1 ordering at GritClawProvider.tsx:282-304). Identity-stable when empty. */
export const mergeWake = (
  res: WakeResult,
  existing: ChatMessage[]
): ChatMessage[] => {
  const greetings = pendingToMessages(res.pending);
  if (res.greeting)
    greetings.push(assistantRow(res.greeting, res.ui_blocks ?? []));
  return greetings.length ? [...greetings, ...existing] : existing;
};
